import _OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoCard from './info';
import Leaderboard from './leaderboard';
import Progression from './progression';
import Sponsors from './sponsors';
function BttfHome({
  Button,
  challengeCardBlock,
  ownGeogroup,
  event,
  defaultParticipationGroup,
  onOwnCompanyClick,
  selectTab,
  selectLeaderboardSize,
  displayLeaderboard
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    paddingY: 3,
    sx: {
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@800': 'row'
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 'calc(100% - 344px)'
    }
  }, challengeCardBlock, /*#__PURE__*/React.createElement(Progression, {
    event: event
  }), /*#__PURE__*/React.createElement(InfoCard, {
    event: event
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 320
    }
  }, /*#__PURE__*/React.createElement(Sponsors, {
    defaultParticipationGroup: defaultParticipationGroup,
    event: event
  }), event.dedicatedWebsiteUrl && /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flexShrink: 0
    }
  }, "\uD83C\uDF0D"), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 700,
      lineHeight: 1.6
    },
    variant: "body2"
  }, t('commons.challenges.official_website'))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 0.5
  }, /*#__PURE__*/React.createElement(_Typography, {
    component: "a",
    href: event.dedicatedWebsiteUrl,
    rel: "noreferrer",
    sx: {
      color: '#326ac2',
      fontSize: 16,
      fontWeight: 600,
      textDecoration: 'none'
    },
    target: "_blank",
    variant: "body2"
  }, event.dedicatedWebsiteUrl.replace('https://', '').replace('http://', '')), /*#__PURE__*/React.createElement(_OpenInNewOutlined, {
    sx: {
      color: '#326ac2',
      fontSize: 16
    }
  }))), /*#__PURE__*/React.createElement(Leaderboard, {
    Button: Button,
    event: event,
    onOwnCompanyClick: onOwnCompanyClick,
    ownGeogroup: ownGeogroup,
    selectLeaderboardSize: size => {
      selectTab('leaderboard');
      selectLeaderboardSize(size);
      displayLeaderboard(true);
    }
  }))));
}
export default BttfHome;